<!-- AI: Status: "in progress", Type: Component, SubType: WizardStep, Reason: Step 3 done screen -->
<div class="flex flex-column align-items-center justify-content-center p-6 gap-4">

    <!-- Success Icon -->
    <div class="flex align-items-center justify-content-center border-circle bg-green-500 text-white"
         style="width: 5rem; height: 5rem;">
        <i class="fa-regular fa-check text-4xl"></i>
    </div>

    <!-- Success Message -->
    <div class="text-center">
        <h2 class="mt-0 mb-2">Erfolgreich erstellt!</h2>
        <p class="text-500 text-lg mt-0 mb-1">
            Der Berechnungslogiktyp <strong>"{{ typeName }}"</strong> wurde erstellt.
        </p>
        <p class="text-500 mt-0">
            {{ logicCount }} Logik-Block{{ logicCount !== 1 ? 'e' : '' }} zugewiesen — Felder und Zuordnungen wurden automatisch angelegt.
        </p>
    </div>

    <!-- Action -->
    <p-button label="Zum Berechnungslogiktyp"
              icon="fa-regular fa-arrow-right"
              iconPos="right"
              size="large"
              (onClick)="onGoToType()">
    </p-button>

</div>
